module.exports = __webpack_public_path__ + "img/54.3fb32b11.png";